import * as React from 'react';

import {TIMELINE_ENTRY_ICONS} from 'shells/timeline/gutter/consts';

import {TimelineEntryIcon} from '../../gutter/timeline-entry-icon';
import type {TimelineEntryIconVariant} from '../../gutter/types';

import {TimelineHeader} from '../header/timeline-header';
import type {Props as TimelineHeaderProps} from '../header/timeline-header';

import styles from './timeline-modal-header.module.css';

type Props = {
    iconVariant: TimelineEntryIconVariant;
} & TimelineHeaderProps;

export function TimelineModalHeader(props: Props) {
    const {iconVariant, ...timelineHeaderProps} = props;

    return (
        <div className={styles['timeline-modal-header']}>
            <TimelineHeader {...timelineHeaderProps} showEmailAddressTooltip={true} />
            {/* @ts-expect-error */}
            <TimelineEntryIcon icon={TIMELINE_ENTRY_ICONS[iconVariant]} />
        </div>
    );
}
